// โหมด "ดูในฐานะผู้ใช้" ของ dev/Support — แถบแจ้งเตือนบนทุกหน้า + ฟังก์ชันเข้า/ออกโหมด
// server เป็นผู้กำหนดทุกอย่าง (session) หน้าเว็บแค่ล้าง cache ของ insight แล้วโหลดใหม่
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { Box, Button, Typography } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Swal from 'sweetalert2';
import api from '../../adapters/api';
import { useInsightMe } from './useInsightInline';

const PERSONA_LABELS = {
  sales_member: 'เซลล์', sales_head: 'หัวหน้าขาย', salesadmin_member: 'ธุรการ', salesadmin_head: 'หัวหน้าธุรการ',
};
export const personaText = list => (list || []).map(p => PERSONA_LABELS[p] || p).join(', ');

const resetInsightCache = qc => qc.removeQueries({ predicate: q => String(q.queryKey[0]).startsWith('insight') });

export async function startViewAs(qc, userCode) {
  try {
    const { data } = await api.post('/api/insight-console/view-as', { user_code: userCode });
    resetInsightCache(qc);
    return data;
  } catch (err) {
    Swal.fire({
      icon: 'error', title: 'เข้าโหมดดูในฐานะผู้ใช้ไม่สำเร็จ', text: err.response?.data?.error || err.message,
      confirmButtonColor: '#1976d2', confirmButtonText: 'ตกลง',
    });
    return null;
  }
}

export async function stopViewAs(qc) {
  await api.delete('/api/insight-console/view-as').catch(() => {});
  resetInsightCache(qc);
}

export default function ViewAsBanner() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const { data: me } = useInsightMe();
  if (!me?.viewAs) return null;
  return (
    <Box
      sx={{
        display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap',
        px: 2, py: 0.5, bgcolor: '#fff3e0', borderBottom: '1px solid #ffb74d',
      }}
    >
      <VisibilityIcon sx={{ fontSize: 18, color: '#e65100' }} />
      <Typography variant="body2" sx={{ flex: 1, minWidth: 0 }}>
        กำลังดูในฐานะ <b>{me.viewAs.user_name} ({me.viewAs.user_code})</b> · {personaText(me.personas)} — อ่านอย่างเดียว
        ข้อมูล insight ทุกจุดเป็นของผู้ใช้นี้ ส่วนเมนูอื่นของเว็บยังเป็นบัญชีของคุณ
      </Typography>
      <Button
        size="small" variant="contained" color="warning"
        onClick={async () => { await stopViewAs(qc); navigate('/insight-console'); }}
      >
        ออกจากโหมดนี้
      </Button>
    </Box>
  );
}
